import { isAxiosError } from 'axios';

const DETAIL_KEYS = ['detail', 'message', 'msg', 'error', 'description'] as const;

const extractDetail = (value: unknown): string | undefined => {
  if (!value) {
    return undefined;
  }

  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    const parts = value.map(item => extractDetail(item)).filter((part): part is string => Boolean(part));

    if (parts.length > 0) {
      return parts.join(', ');
    }

    return undefined;
  }

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;

    for (const key of DETAIL_KEYS) {
      const detail = extractDetail(record[key]);
      if (detail) {
        return detail;
      }
    }
  }

  return undefined;
};

export const getApiErrorMessage = (error: unknown, fallbackMessage = 'Etwas ist schiefgelaufen'): string => {
  if (isAxiosError(error)) {
    const detail = extractDetail(error.response?.data);
    if (detail) {
      return detail;
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  const detail = extractDetail(error);
  if (detail) {
    return detail;
  }

  if (typeof error === 'string') {
    return error;
  }

  try {
    return JSON.stringify(error);
  } catch {
    return fallbackMessage;
  }
};
